<template>
    <v-layout column>
        <v-spacer class="my-2"></v-spacer>
        <v-flex xs12>
            <div class="text-xs-left">
                <v-btn
                        flat
                        @click="goBack"
                >
                    <v-icon left small>fal fa-chevron-left</v-icon>
                    {{ $vuetify.t('$vuetify.back') }}
                </v-btn>
            </div>

            <v-card flat style="background: transparent" fill-height>
                <v-card-title>
                    <span class="headline">{{ $vuetify.t('$vuetify.gdpr_agreement.program_terms_policy') }} {{loyalty_program_name}}</span>
                </v-card-title>
                <v-card-text v-html="terms_policy">
                </v-card-text>
            </v-card>

        </v-flex>
    </v-layout>
</template>
<script>
    import {apiFetch} from '../../_helpers';

    export default {
        name: "TermsPolicy",
        data: () => ({
            loyalty_program_name: null,
            terms_policy: null,
            loggedIn: false,
        }),
        methods: {
            //@modified ana.castro 2019.12.03 The "Help" Menu should be replaces by an "Info" Menu with two
            // options: access the Help page and access the Terms and Conditions page;
            // The Login interface must display a link to access the Terms and Conditions
            goBack() {
                if (!this.loggedIn) {
                    this.$router.push({name: "login"});
                } else {
                    this.$router.push({name: "info-options"});
                }

            },
        },
        mounted() {
            // eslint-disable-next-line
            apiFetch('getprofiledefinitions/').then(result => {
                    this.terms_policy = result.text_tc_accept_complete;
                },
                // eslint-disable-next-line
                error => {
                    this.$log.warn("error");
                });

            this.loyalty_program_name = this.$store.state.configs.loyaltyProgramName;
            this.loggedIn = localStorage.getItem('user');
        }
    }
</script>
